(function () {
    'use strict';
    var m = angular.module('profiles');
    m.factory('defaultScanDetailsLogic', ["fileScanDetailsLogicCore", "fileDao", "widgetPolling", "metaInfoLogicCore", "$q", function (fileScanDetailsLogicCore, fileDao, widgetPolling, metaInfoLogicCore, $q) {
        var downloadReportButtonId = 'download-report-button';
        var scanVirusButtonId = 'scan-with-virus-total-button';
        function addDownloadReportButton(wrapper, link, label) {
            wrapper.buttons = wrapper.buttons || [];
            var downloadButton = _(wrapper.buttons).find(function (button) {
                return button.id === downloadReportButtonId;
            });
            if (!downloadButton) {
                downloadButton = {
                    'class': 'btn-blue',
                    label: label || 'Download Report',
                    position: 'right',
                    id: downloadReportButtonId
                };
                wrapper.buttons.push(downloadButton);
            }
            downloadButton.onclick = function () {
                window.open(link, '_blank');
            };
        }
        function removeButtons(wrapper, buttonId) {
            if (!wrapper.buttons) {
                return;
            }
            var btnIdx = _(wrapper.buttons).findIndex(function (button) {
                return button.id === buttonId;
            });
            if (btnIdx === -1) {
                return;
            }
            wrapper.buttons.splice(btnIdx, 1);
        }
        function addScanVirusButton(wrapper, link, label) {
            wrapper.buttons = wrapper.buttons || [];
            var scanVirusButton = _(wrapper.buttons).find(function (button) {
                return button.id === scanVirusButtonId;
            });
            if (!scanVirusButton) {
                scanVirusButton = {
                    class: 'btn-blue',
                    label: label || 'Scan with VirusTotal',
                    position: 'right',
                    id: scanVirusButtonId
                };
                wrapper.buttons.push(scanVirusButton);
            }
            scanVirusButton.onclick = function () {
                window.open(link, '_blank');
            };
        }
        return function ($scope, logic) {
            var id = logic.entityId || widgetPolling.scope().id;
            var coreOptions = {
                retrieve: function () {
                    var query = fileDao.scanDetails(logic.app, id, logic.entityType, logic.historyTime).converter(function (input) {
                        var wrapper = $scope.model.modalWrapper || $scope.model.wrapper;
                        var haveDownloadLink = false;
                        var malLink = '';
                        if (logic.app === 'solgate' && input.data.have_word_report) {
                            haveDownloadLink = true;
                            addDownloadReportButton(wrapper, '/api/v1/solgate/report/' + logic.entityType + '/' + id);
                        }
                        if (logic.app === 'av_cisco' && input.data.have_pdf_report) {
                            haveDownloadLink = true;
                            addDownloadReportButton(wrapper, '/api/v1/av_cisco/report/' + logic.entityType + '/' + id);
                        }
                        if (logic.app === 'lastline_av_file' && input.data.have_pdf_report) {
                            haveDownloadLink = true;
                            addDownloadReportButton(wrapper, '/api/v1/lastline_av/report/lastline_av_file/' + logic.entityType + '/' + id);
                        }
                        if (logic.app === 'lastline_av_hash' && input.data.have_pdf_report) {
                            haveDownloadLink = true;
                            addDownloadReportButton(wrapper, '/api/v1/lastline_av/report/lastline_av_hash/' + logic.entityType + '/' + id);
                        }
                        if (logic.app === 'lastline_te') {
                            haveDownloadLink = true;
                            addDownloadReportButton(wrapper, '/api/v1/external_sectool/report/lastline_te/' + logic.entityType + '/', +id);
                        }
                        if (logic.app === 'atp_fireeye' && input.data.have_report) {
                            haveDownloadLink = true;
                            addDownloadReportButton(wrapper, '/api/v1/atp_fireeye/' + logic.entityType + '/' + id, 'View Report');
                        }
                        if (logic.app === 'checkpoint_url' && (logic.entityType === 'ms_teams_message' || logic.entityType === 'slack_message') && input.data.highest_risk_link) {
                            malLink = 'https://www.virustotal.com/en/url/submission/?force=1&url=' + encodeURIComponent(input.data.highest_risk_link);
                            addScanVirusButton(wrapper, malLink, 'Scan with VirusTotal');
                        }
                        if (!haveDownloadLink) {
                            removeButtons(wrapper, downloadReportButtonId);
                        }
                        if (!malLink) {
                            removeButtons(wrapper, scanVirusButtonId);
                        }
                        return $q.when(input);
                    });
                    if (logic.resultsConverter) {
                        query.converter(logic.resultsConverter);
                    }
                    return query;
                },
                advanced: logic.advanced,
                whiteList: logic.whiteList,
                blackList: logic.blackList || [],
                coreLogic: metaInfoLogicCore,
                moduleLabels: logic.moduleLabels,
                autoByEntityInfo: logic.autoByEntityInfo,
                extendEntityInfo: logic.extendEntityInfo,
                ordering: 'entityOrder'
            };
            return fileScanDetailsLogicCore($scope, logic, coreOptions);
        };
    }]);
}());